export var MAX_SELECTION_COUNT = 180;
